<template>
  <div class='h100'>
    <!--:sortSettings='sortOptions' :allowPaging='false' :pageSettings='pageSettings' :rowSelected='onRowSelected' :editSettings='editOptions'-->
    <ejs-grid ref='grid' :pageSettings='pageSettings' height='90%' :dataSource='data' :columns='tableColumns' :allowSorting='true' :rowSelected='onRowSelected'
      :query='gridQuery' :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
    </ejs-grid>
     <ejs-pager ref='pager' @click='getPageImportTableData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager> 
  
    <CustomDialog ref='searchDialog' :element='searchDialogSetting.element' :styles='searchDialogSetting.styles' @afterClose="dialogClose">
      <template v-slot:dialog-content>
        <FormFilter :isImport='isImport' ref='searchContent'></FormFilter>
      </template>
    </CustomDialog>
    <div class='h-system-hide-upload'>
      <ejs-uploader ref='uploadObj' id='defaultfileupload' name='mFile' :uploading='onUpload' :selected='onSelected'
      :asyncSettings='uploader.path' :autoUpload='uploader.autoUpload' :multiple='false' :allowedExtensions='uploader.extensions'></ejs-uploader>
    </div>
  </div>
</template>
<script>
import { Reorder, Resize, ExcelExport, Sort } from '@syncfusion/ej2-vue-grids';
import { DataManager, Query } from '@syncfusion/ej2-data';
import CustomDialog from '../../common/CustomDialog';
import FormFilter from '../util/formFilter/FormFilter';
import bus from '../bus.js';
import { EventBus } from '../../../plugins/eventBus';
import i18n from '../../../plugins/i18n.js';
import socketInstance from '../../../plugins/stompSock';

export default {
  name: 'ImportTable',
  components: {
    CustomDialog,
    FormFilter
  },
  props: {
    isImport: { type: Boolean, default: false },
  },
  data() {
    return {
      uploader: {
        path: {
          saveUrl: '/lte/ems/track/TrackImportData',
          removeUrl: ''
        },
        extensions: '.json',
        autoUpload: true
      },
      pageSettings: {
        // template: '<ejs-textbox></ejs-textbox>',
        pageSizes: [15,30,50,100],
        pageSize: 15
      },
       page: {
          pageNo: 1,
          pageSize: 100,
          totalCount: 0,
          pageCount: 10
        },
        trackNowTabPage:'',
      selectionOptions: { type: 'Multiple' },
      editOptions: { allowAdding: true, allowDeleting: true, newRowPosition: 'Top' },
      sortOptions: { columns: [{ field: 'timeShw', direction: 'Descending' }] },
      locale: localStorage.getItem('locale'),
      dialogFlag: true,
      primaryTableColumns: [],
      tableColumns: [],
      queryConditions: {
        conditions: {
          condition: '1',
          filterType: '2'
        }
      },
      directoryName: null,
      data: [],
      dataAll:[],
      filtetAllData: {},
      gridQuery: new Query(),
      primaryDatas: [],
      searchDialogSetting: {
        styles: {
          width: '410px',
          height: this.isImport ? '480px' : '510px',
          model: true,
          visible: false
        },
        element: {
          // target: '#app',
          refName: 'search',
          title: this.$ts('Track.queryTrack'),
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$ts('Track.cancel') } },
            { click: this.searchConfirmFunc, buttonModel: { content: this.$ts('Track.confirm'), isPrimary: true } }
          ]
        }
      },
      shipColumns: [
        {
          field: 'ShippedDate',
          headerText: 'Shipped Date',
          format: 'yMd',
          textAlign: 'Right',
          width: 150,
          minWidth: 10
        }, {
          field: 'ShipCountry',
          headerText: 'Ship Country',
          width: 150,
          minWidth: 10
        }
      ],
      websocketSetting: [
        { topic: '/user/#/TrackReportServer', clientId: '', callback: this.websocketCallback }
      ]
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, Sort]
  },
  methods: {
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$ts('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$ts('Alarm.too_many_checked')});
        return false;
      }
      return selectedRecords;
    },
    importTrackFunc() {
      // 导入方法
      document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
    },
    onSelected(args) {
      if (args.filesData && args.filesData.length > 0) {
        if (args.filesData[0].type !== 'json') {
          EventBus.$emit('toast', {type: 'warning', content: this.$ts('Track.importFileError')});
        }
      }
    },
    onUpload(args) {
      // 调用导入ajax方法
      if (args.fileData) {
        const { fileData } = args;
        if (fileData.type !== 'json') {
          EventBus.$emit('toast', {type: 'warning', content: this.$ts('Track.importFileError')});
          args.cancel = true;
        } else {
          const config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          const formData = new FormData();
          formData.append('mFile', fileData.rawFile);
          this.$axios.post('/lte/ems/track/trackImportData', formData, config).then((response) => {
            if (response && response.status === 200) {
              this.$refs.uploadObj.clearAll();
              const resultData = response.data.resultVal;
              this.data = resultData.result;
              // this.primaryDatas = resultData.result;
              this.getColumnsByNeID(resultData.displaySoftwareVersion, resultData.neType, resultData.typeId);
            }
          });
        }
      }
      args.cancel = true;
    },
   async exportTrackFunc() {
        const args = this.trackNowTabPage.value;
       await this.$axios.get(`/lte/ems/track/taskFilesDetail/${args[0].directoryName}/${args[0].fileName}`).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            const resultData = response.data.resultVal;
            console.log("response.data===",response.data)
            this.dataAll = resultData;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });

      const This = this;
      if (this.dataAll.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: This.$ts('Track.noDataToExport')});
        return;
      }
      new DataManager({ json: this.dataAll }).executeQuery(This.gridQuery).then((e) => {
        if (false) {//暂时excel导出不支持码流结构体，字节数较大，cell存不下，如果需要支持，建议导出成test文件
          const uuidArr = [];
          let fileName = '';
          if (This.queryConditions.conditions === '') {
            e.result.forEach(node => {
              uuidArr.push(node.uuid);
              if (fileName.indexOf(node.fileName) == -1) {
                fileName = node.fileName + ","
              }
            })
          }
          if (fileName != '') {
            fileName = fileName.substring(0, fileName.length - 1)
          }

          const params = {
            directoryName: This.directoryName,
            fileName: fileName,
            uuidArr: uuidArr,
            tableColumns: This.primaryTableColumns,

          };
          const config = {
            responseType: 'blob'
          };
          This.$axios.post('/lte/ems/track/trackFileDataExport', params, config).then((res) => {
            const link = document.createElement('a');
            const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            const num = new Date().getTime();
            link.setAttribute('download', `${this.$ts('Track.signalDataExport')}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        } else {
          const exportProperties = {
            fileName: `${This.$ts('Track.signalDataExport')}.xlsx`,
            dataSource: e.result,
            includeHiddenColumn: true
          };
          This.$refs.grid.excelExport(exportProperties);
        }
      });

    },
    onRowSelected(args) {
      if (args.data.fileName.indexOf('pcap') > -1) {
        return;
      };
      const This = this;
      const params = {
        neId: args.data.neId,
        fileName: args.data.fileName,
        uuid: args.data.uuid
      };
      This.$axios.post('/lte/ems/track/getTreeWithParseCode', params).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          This.$emit('rowJson', result);
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    dialogClose() {
      this.dialogFlag = true;
    },
    dialogHide() {
      this.$refs.searchDialog.clear();
      this.$refs.searchDialog.close();
    },
    websocketInit() {
      this.websocketSetting[0].clientId = this.trackNowTab ? `track_${this.trackNowTab.value[0].taskId}` : '';
      if (socketInstance.stompClient == null) {
        socketInstance.init(this.websocketSetting);
      } else {
        socketInstance.dynamicSubscribe(this.websocketSetting[0].topic, this.websocketSetting[0].clientId, this.websocketCallback);
      }
    },
    websocketCallback(msg) {
      // var st = +new Date();
      if ((this.queryConditions.conditions.condition !== '0' || this.queryConditions.conditions.filterType === '2') && this.dialogFlag) {
        let arr = JSON.parse(msg.body).concat(this.data);
        if (arr.length > 399) {
          arr.splice(300, arr.length);
        }
        this.data = arr;
      }
      // console.log("es6666666666666666666666666666666666666", ' use time: ' + (+new Date() - st) + 'ms');
    },
    searchConfirmFunc() {
      // 信令过滤确认事件
      const searchData = this.$refs.searchContent.getDatas();
      if (searchData) {
        this.queryConditions.conditions = searchData;
        this.dialogHide();
        this.searchTaskData();
      }
    },
    searchTask() {
      this.$refs.searchContent.setFilter(this.filtetAllData);
      this.$refs.searchContent.setDatas(this.queryConditions.conditions);
      this.$refs.searchDialog.show();
      this.dialogFlag = false;
    },
    searchTaskData() {
      const { conditions } = this.queryConditions;
      if (conditions.filterType === '2') {
        // this.data = this.primaryDatas;
        this.gridQuery = new Query();
      } else {
        let value = ''
        let conditionsName =  conditions.attributeName;
        if (conditions.attributeValue3 !== '') {
          let time = new Date(conditions.attributeValue3).getTime()/1000 + "000000";
          value = parseInt(time);
          conditionsName = 'timeShw';
        } else if (conditions.attributeValue2 !== '') {
          value = conditions.attributeValue2;
        } else {
          // let name = this.data[0][conditions.attributeName];
          // const type = typeof name;
          if (conditions.attributeName == 'neId') {
            value = parseInt(conditions.attributeValue1);
          } else {
            value = conditions.attributeValue1;
          }
        }
        const dataQuery = new Query().where(conditionsName, conditions.cron, value);
        this.gridQuery = dataQuery;
      }
    },
    activeTrackPage() {
      // 激活任务
      this.$axios.post(`/lte/ems/track/activeTask/${this.trackNowTab.value[0].taskId}`).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === '0') {
          EventBus.$emit('toast', {type: 'success', content: this.$ts('Track.success')});
          bus.$emit('refreshTrackTable');
          this.getImportTableData(this.trackNowTab.value);
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    hangupTrackPage() {
      // 挂起任务
      this.$axios.post(`/lte/ems/track/pauseTask/${this.trackNowTab.value[0].taskId}`).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === '0') {
          EventBus.$emit('toast', {type: 'success', content: this.$ts('Track.success')});
          bus.$emit('refreshTrackTable');
          this.getImportTableData(this.trackNowTab.value);
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    finishTrackPage() {
      // 完成任务
      this.$axios.post(`/lte/ems/track/finishTask/${this.trackNowTab.value[0].taskId}`).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === '0') {
          EventBus.$emit('toast', {type: 'success', content: this.$ts('Track.success')});
          bus.$emit('refreshTrackTable');
          this.getImportTableData(this.trackNowTab.value);
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    getColumnsByNeID(version, neType, typeId) {
      let columnsDatas = JSON.parse(localStorage.getItem('trackColumns'));
      if (!columnsDatas) {
        columnsDatas = {};
      }
      if (!columnsDatas[`${version}${neType}${this.locale}`]) {
        this.$axios.get(`/lte/ems/track/queryGridColumnConfig?version=${version}&neType=${neType}`).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            const result = response.data.resultVal;
            const gridColumn = result[result.findIndex(v => v.typeID === typeId)];
            if (!columnsDatas[`${version}${neType}${this.locale}`]) {
              columnsDatas[`${version}${neType}${this.locale}`] = {};
            }
            result.forEach(element => {
              columnsDatas[`${version}${neType}${this.locale}`][element.typeID] = element;
            });
            localStorage.setItem('trackColumns', JSON.stringify(columnsDatas));
            const tableColumns = gridColumn.columns.map(item => {
              item.textAlign = 'Center';
              item.clipMode = 'EllipsisWithTooltip';
              item.minWidth = '10';
              item.autoFit = true;
              if (item.field == 'taskId') {
                  item.valueAccessor = (grids, data) => {
                    return this.directoryName;
                  }
              }else if (item.valueAccessor) {
                const arr = item.valueAccessor;
                item.valueAccessor = (grids, data) => {
                  const map = new Map(arr);
                  return map.get(data[grids]);
                };
              } else if (item.field == 'asn' || item.field == 'pri') {
                item.valueAccessor = (grids, data) => {
                  return JSON.stringify(data[grids]);
                };
              }
              return item;
            });
            // tableColumns.push({ field: 'uuid', headerText: 'uuid', width: '10%', visible: false});
            this.tableColumns = tableColumns;
            const trackColumns = JSON.parse(localStorage.getItem('trackColumns'))[`${version}${neType}${this.locale}`][typeId];
            this.primaryTableColumns = trackColumns.columns;
            this.filtetAllData = trackColumns;
            this.$refs.searchContent.setFilter(trackColumns);
            this.queryConditions.conditions = '';
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      } else {
        const gridColumn = columnsDatas[`${version}${neType}${this.locale}`][typeId];
        const tableColumns = gridColumn.columns.map(item => {
          item.textAlign = 'Center';
          item.clipMode = 'EllipsisWithTooltip';
          item.minWidth = '10';
          item.autoFit = true;
          if (item.field == 'taskId') {
            item.valueAccessor = (grids, data) => {
              return this.directoryName;
            }
          }else if (item.valueAccessor) {
            const arr = item.valueAccessor;
            item.valueAccessor = (grids, data) => {
              const map = new Map(arr);
              return map.get(data[grids]);
            };
          }
          return item;
        });
        // tableColumns.push({ field: 'uuid', headerText: 'uuid', width: '10%', visible: false});
        this.tableColumns = tableColumns;
        const trackColumns = JSON.parse(localStorage.getItem('trackColumns'))[`${version}${neType}${this.locale}`][typeId];
        this.primaryTableColumns = trackColumns.columns;
        this.filtetAllData = trackColumns;
        this.$refs.searchContent.setFilter(trackColumns);
        this.queryConditions.conditions = '';
      }
    },
    getImportTableData(args) {
      // 获取表格数据
      const This = this;
      This.getColumnsByNeID(args[0].displaySoftwareVersion, args[0].oamTypeCode, args[0].typeId);
      if (This.isImport === true) {
        This.directoryName = args[0].directoryName;

        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
          const pageNo = parseInt(This.page.pageNo, 10);
          const pageSize = parseInt(This.page.pageSize, 10);

        This.$axios.get(`/lte/ems/track/taskFilesDetailPage/${args[0].directoryName}/${args[0].fileName}?pageNo=`+pageNo+`&pageSize=`+pageSize).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            const resultData = response.data.resultVal;
           // console.log("response.data===",response.data)
            This.data = resultData;
            This.primaryDatas = resultData;
            This.page.totalCount =resultData.totalCount;
           // console.log(This.data);
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      } else {
        This.directoryName = args[0].taskId.toString();
      }
    },
    getPageImportTableData(){
      this.getImportTableData(this.trackNowTabPage.value);
    }
  },
  mounted() {
    const trackNowTab = JSON.parse(localStorage.getItem('trackNowTab'));
    this.trackNowTab = trackNowTab;
    this.trackNowTabPage = trackNowTab;
    if (!this.isImport) {
      // this.getImportTableData(trackNowTab.value);
      this.websocketInit();
      bus.$on(trackNowTab.name, (args) => {
        this.getImportTableData(args);
      });
    } else {
      bus.$on(trackNowTab.name, (args) => {
        this.getImportTableData(args);
      });
    }
  }
};
</script>
